module.exports = __webpack_public_path__ + "static/python_icon-1731e2e1037386ca000e5575d953b12a.svg";